<template>
  <div class="crm-settings-overlay">
    <div class="crm-settings-modal">
      <div class="crm-settings-header">
        <div class="title">Settings</div>
      </div>
      <div class="crm-settings-body">
        <div class="setting-widget divider">
          <div class="setting-header">
            <h3>Instructors</h3>
          </div>
          <div class="setting-body">
            <div class="settting-info">
              <h4>Instructors invitations</h4>
              <p>Who is allowed to invite instructors</p>
            </div>
            <div class="setting-option">
              <miltSelect all_label="Everyone" v-model="form.manager_invitation_allowed"
                :content="permission_categories"></miltSelect>
            </div>
          </div>
          <div class="setting-body">
            <div class="settting-info">
              <h4>Schools</h4>
              <p>Show all schools to everyone</p>
            </div>
            <div class="setting-option">
              <div class="switch-input">
                <span class="no-label">No</span>
                <switches theme="c-switch" type-bold="true" color="blue" v-model="form.show_department"></switches>
                <span class="yes-label">Yes</span>
              </div>
            </div>
          </div>
          <div class="setting-body">
            <div class="settting-info">
              <h4>Classes</h4>
              <p>Show all classes to everyone</p>
            </div>
            <div class="setting-option">
              <div class="switch-input">
                <span class="no-label">No</span>
                <switches theme="c-switch" type-bold="true" color="blue" v-model="form.show_team"></switches>
                <span class="yes-label">Yes</span>
              </div>
            </div>
          </div>
        </div>
        <div class="setting-widget divider">
          <div class="setting-header">
            <h3>Students</h3>
          </div>
          <div class="setting-body">
            <div class="settting-info">
              <h4>Students invitations</h4>
              <p>Who is allowed to invite students</p>
            </div>
            <div class="setting-option">
              <miltSelect all_label="Everyone" :content="permission_categories"
                v-model="form.invite_consultant_allowed"></miltSelect>
            </div>
          </div>
          <div class="setting-body">
            <div class="settting-info">
              <h4>Students privacy</h4>
              <p>Show all students to everyone</p>
            </div>
            <div class="setting-option">
              <div class="switch-input">
                <span class="no-label">No</span>
                <switches theme="c-switch" type-bold="true" color="blue" v-model="form.show_consultant"></switches>
                <span class="yes-label">Yes</span>
              </div>
            </div>
          </div>
        </div>
        <div class="setting-widget">
          <div class="setting-header">
            <h3>Notifications</h3>
          </div>

          <div class="setting-body">
            <div class="settting-info">
              <h4>Notification</h4>
              <p>Get notified for every activity</p>
            </div>
            <div class="setting-option">
              <div class="switch-input">
                <span class="no-label">No</span>
                <switches theme="c-switch" type-bold="true" color="blue" v-model="form.notified_all_activities">
                </switches>
                <span class="yes-label">Yes</span>
              </div>
            </div>
          </div>
        </div>

        <div class="crm-settings-footer">
          <div class="options">
            <c-button :loading="crm_settings_loading" @click="submitCrmSettings()" class="btn-submit">Accept</c-button>
          </div>
        </div>
      </div>
      <div class="crm-settings-body">
        <div class="setting-widget">
          <div class="setting-header">
            <h3>Connect Accounts</h3>
          </div>
          <div class="setting-body account-item">
            <div class="settting-info">
              <h4 class="account-title">
                <img src="@/assets/icons/google.svg" />
                Google
              </h4>
              <p>Connect your Google account to sync your emails</p>
            </div>
            <div class="setting-option">
              <widgetButton :loading="false" @click="connectAccount('google')" class="
        btn-transparent-primary
      ">
                Connect
              </widgetButton>
            </div>
          </div>
          <div class="setting-body account-item">
            <div class="settting-info">
              <h4 class="account-title">
                <img src="@/assets/icons/microsoft.svg" />
                Microsoft
              </h4>
              <p>Connect your Microsoft account to sync your emails</p>
            </div>
            <div class="setting-option">
              <widgetButton :loading="false" @click="connectAccount('microsoft')" class="
        btn-transparent-primary
      ">
                Connect
              </widgetButton>
            </div>
          </div>
        </div>
      </div>
      <div class="crm-settings-footer">
        <div class="options">
          <button @click="closeCrmSettings()" class="btn-close">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import miltSelect from "@/components/Partials/miltSelect.vue";
export default {
  name: "crm-settings",
  components: {
    miltSelect,
  },
  props: {},
  data: () => {
    return {
      permission_categories: [
        { name: "Admin", value: "super-manager" },
        { name: "Division Manager", value: "department-manager" },
        { name: "Team Manager", value: "team-manager" },
      ],
      show_crm_settings_modal: false,
      crm_settings_loading: false,
      enabled: false,
      form: {
        manager_invitation_allowed: [],
        show_department: false,
        show_team: false,
        invite_consultant_allowed: [],
        show_consultant: false,
        notified_all_activities: false,
      },
      connected_accounts: [],
    };
  },
  mounted() {
    let vm = this;
    vm.getCrmSettings();
    vm.getConnectedAccounts();
  },
  computed: {},
  watch: {},
  methods: {
    getConnectedAccounts() {
      let vm = this;
      vm.$store.dispatch("GET_CONNECTED_ACCOUNTS").then((response) => {
        vm.connected_accounts = response.data;
      });
    },
    connectAccount(account) {
      let vm = this;
      vm.$store.dispatch("CONNECT_ACCOUNT", account).then((response) => {
        console.log(response);
        // TODO: redirect to the url on new tab
        window.open(response.data.url, "_blank");

      })
        .catch((error) => { });
    },
    closeCrmSettings() {
      let vm = this;
      vm.$emit("close", null);
    },
    submitCrmSettings() {
      let vm = this;
      vm.crm_settings_loading = true;
      vm.$store
        .dispatch("SUBMIT_SETTING", vm.form)
        .then((response) => {
          vm.crm_settings_loading = false;
          vm.$emit("close", null);
        })
        .catch((error) => {
          vm.crm_settings_loading = false;
        });
    },
    getCrmSettings() {
      let vm = this;
      vm.$store
        .dispatch("GET_SUBMIT_SETTING", {
          setting_keys: [
            "manager_invitation_allowed",
            "show_department",
            "show_team",
            "invite_consultant_allowed",
            "show_consultant",
            "notified_all_activities",
          ],
        })
        .then((response) => {
          response.data.forEach((item) => {
            if (item.value_string) {
              vm.form[item.key] =
                item.value_string == "0"
                  ? false
                  : item.value_string == "1"
                    ? true
                    : JSON.parse(item.value_string);
            } else {
              vm.form[item.key] = item.value == 0 ? false : true;
            }
          });
        })
        .catch((error) => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.crm-settings-overlay {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba($color: #000000, $alpha: 0.6);
  padding-top: 100px;
  z-index: 9999999;
  overflow-y: auto;

  .crm-settings-modal {
    background: rgb(236, 236, 236);
    padding: 30px 30px;
    width: 100%;
    border-radius: 5px;
    width: 600px;
    display: block;
    margin: 0 auto;

    @media (min-width: 300px) and (max-width: 630px) {
      padding: 30px 20px;
    }

    .crm-settings-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .title {
        color: #0884af;
        font-size: 20px;
        font-weight: 800;
      }

      .company-info {
        display: flex;
        align-items: center;

        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 50%;
          margin-right: 6px;
        }

        .company-name {
          font-weight: 800;
          color: #0884af;
          font-size: 16px;
        }
      }
    }

    .crm-settings-body {
      background: #fff;
      border-radius: 5px;
      padding: 15px;
      margin-bottom: 20px;

      .setting-widget {
        margin-top: 15px;

        &.divider {
          border-bottom: 1px solid #ddd;
        }

        .setting-header {
          margin-bottom: 4px;

          h3 {
            color: #0884af;
          }
        }

        .setting-body {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;

          &.account-item {
            padding: 10px 0px;
            border-bottom: 1px solid #ddd;
          }

          .settting-info {
            h4 {
              color: #676767;
            }

            .account-title {
              display: flex;
              align-items: center;

              img {
                width: 20px;
                height: 20px;
                margin-right: 6px;
              }
            }

            p {
              color: #676767;
              font-size: 12px;
              margin: 0px;
            }
          }

          .setting-option {
            display: flex;
            justify-content: flex-end;
            width: 160px;

            .switch-input {
              display: flex;
              align-items: center;
              position: relative;

              .yes-label {
                margin-left: 8px;
              }

              .no-label {
                margin-right: 8px;
              }
            }
          }
        }
      }
    }

    .crm-settings-footer {
      .options {
        display: flex;
        width: 100%;

        .btn-submit {
          width: 148px;
          height: 40px;
          background: #1ba5a4;
          border-radius: 5px;
          color: #fff;
          margin-right: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .btn-close {
          color: #1ba5a4;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.vue-switcher-theme--c-switch {
  &.vue-switcher-color--blue {
    div {
      background-color: lighten(#1ba5a4, 0%);
      top: unset;

      &:after {
        // for the circle on the switch
        background-color: lighten(#fff, 0%);
      }
    }

    &.vue-switcher--unchecked {
      div {
        background-color: lighten(#c4c4c4, 0%);
        top: unset;

        &:after {
          background-color: lighten(#fff, 0%);
        }
      }
    }
  }
}
</style>